import { isArray, isNil, isObject } from 'lodash';

import { config } from '../../themes';
import type { StitchesCSS } from '../../themes';

/**
 * Map over the breakpoints, and returns a object like:
 * { @bp: `propertie` }
 */
function responsiveStyles(
  prop: any,
  mapper: (val: number | null) => StitchesCSS
) {
  if (isArray(prop)) {
    return prop
      .map((item, index) => {
        if (isNil(item)) {
          return null;
        }

        return {
          [`@${Object.keys(config.media)[index]}`]: mapper(item),
        };
      })
      .filter(Boolean)
      .reduce((prev, current) => ({
        ...prev,
        ...current,
      }));
  }

  if (isObject(prop)) {
    return Object.keys(prop).reduce((styles: any, key: string) => {
      styles[`@${key}`] = mapper(prop[key as keyof typeof prop]);

      return styles;
    }, {});
  }

  if (!isNil(prop)) {
    return mapper(prop);
  }

  return null;
}

export default responsiveStyles;
